import { render, staticRenderFns } from "./RSXDocumentViewFrame.vue?vue&type=template&id=74a5b644&scoped=true"
import script from "./RSXDocumentViewFrame.vue?vue&type=script&lang=js"
export * from "./RSXDocumentViewFrame.vue?vue&type=script&lang=js"
import style0 from "./RSXDocumentViewFrame.vue?vue&type=style&index=0&id=74a5b644&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5b644",
  null
  
)

export default component.exports